// Byte-oriented legacy wire text, not a change to the protocol's character encoding.
// Accept bounded views so decoders never read a neighbouring coalesced frame. Like
// ArrayBuffer.slice, start/end may be negative; omit end to read to the view's end.
export function DecodeByteText(data, start=0, end=undefined)
	{
	const bytes=(ArrayBuffer.isView(data)
		?new Uint8Array(data.buffer,data.byteOffset,data.byteLength)
		:new Uint8Array(data)).subarray(start,end);
	const parts=[];
	// Avoid the engine-specific function-argument limit on large TEXT frames.
	for (let offset=0; offset<bytes.length; offset+=8192)
		parts.push(String.fromCharCode.apply(null,bytes.subarray(offset,offset+8192)));
	return(parts.join(''));
	}
